<div class="d-flex justify-content-around">
  <p style="border-bottom: 1px solid var(--clr-red);" translate>user.connected</p>
  <p class="available-dms" *ngIf="!currentUser?.readOnlyPermissions" (click)="openAvailableDMS(dialogDMS)" translate>user.available</p>
</div>
<div>
  <div class="no-data-message" *ngIf="userDms && !userDms.length" translate>user.notConnected</div>
  <ng-container *ngFor="let dms of userDms">
    <div class="dms-container">
      <div class="d-flex justify-content-between">
        <div>
          <p>{{dms.dms.name | uppercase}}</p>
          <p style="font-size: .8rem;">{{dms.credentials?.username}}</p>
        </div>
        <div class="row">
          <button *ngIf="currentUser?.role.name === 'root' || currentUser?.role.name === 'customer'" class="btn btn-info mr-2"
            (click)="openEditDms(dialogConnect, dms)" translate>global.edit</button>
          <button class="btn btn-default disconnect" (click)="disconnectDms(dms)" translate>user.disconnect</button>
        </div>
      </div>
      <hr>

      <div class="d-flex justify-content-between">
        <div class="w-100">
          <p translate>user.autoUploadImages</p>
        </div>
        <app-general-settings-checkbox mySelect [defaultChecked]='dms?.autoUpload'
          [disabled]='currentUser?.readOnlyPermissions' [checkType2]=true [data]="dms"
          (select)='patchAutoUpload($event)'>
        </app-general-settings-checkbox>
      </div>

      <ng-container *ngIf="isVisibleSpecificationSettings(dms.dms)">
        <hr>
        <div class="d-flex justify-content-between">
          <div>
            <p style="font-size: 1.2rem;"><strong translate>settings.settings</strong></p>
          </div>
          <button class="btn btn-info mr-2" (click)="openSettings(dialogSettingsDMS, dms)" translate>settings.editSettings</button>
        </div>
        <div *ngIf="dms.settings; else noSettings">
          <div *ngIf="dms.settings.exportLanguage">
            <p><strong translate>settings.exportLanguage</strong>:
              <span class="font-weight-600">
                {{ getLanguageLabel(dms.settings.exportLanguage) }}
              </span>
            </p>
          </div>
          <div *ngIf="dms.settings.requiredVehicleSpecificationFields">
            <p><strong translate>settings.requiredVehicleFields</strong>: <span *ngFor="let field of dms.settings.requiredVehicleSpecificationFields" class="required-field">{{ getFieldLabel(field) }}</span></p>
          </div>
        </div>
        <ng-template #noSettings>
          <p translate>settings.noSettingsOptionsDefined</p>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</div>


<!-- Modal DMS -->
<ng-template #dialogDMS let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>user.availableDms</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container *ngFor="let dms of allDms">
      <div class="d-flex justify-content-between p-3">
        <p>{{dms.name}}</p>
        <div>
          <button *ngIf="!dms?.isConnected" class="btn btn-default" (click)="openConnectModal(dialogConnect, dms)"
            translate>user.connect</button>

          <p class="connected-button" *ngIf="dms?.isConnected" translate>user.connected</p>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>


<ng-template #dialogConnect let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{selectedDms?.name}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form *ngIf="!selectedDms.useOauth" #connectForm="ngForm">
      <div class="" style="margin: 10px 0;" *ngFor="let field of selectedDms.requiredFields">
        <label for="">{{getFieldLanguage(field.label)}}</label>
        <select *ngIf="field.type === 'select'" name="{{field.name}}"
          [ngModel]="selectedDmsCredentials ? selectedDmsCredentials[field.name] : field.default"
          class="form-control">
          <ng-container *ngIf="field.options; else customOptions">
            <option *ngFor="let option of field.options" value="{{option.value}}">{{getFieldLanguage(option.label)}}
            </option>
          </ng-container>
          <ng-template #customOptions>
            <ng-container *ngIf="field.name === 'sshKeyId' && !isLoadingSSH">
              <option [ngValue]="undefined">Select SSH</option>
              <option *ngFor="let option of sshKeys" [value]="option.value">{{ option.label }}</option>
            </ng-container>
          </ng-template>
        </select>
        <div *ngIf="field.type === 'password'" class="password-field">
          <show-hide-password icon="fa fa-eye-slash" class="inputbotom">
            <input #userPassword="ngModel" name="{{ field.name }}" type="password" class="form-control input-underline"
              [placeholder]="getFieldLanguage(field.label)"
              [ngModel]="selectedDmsCredentials ? selectedDmsCredentials[field.name] : field.default" required>
          </show-hide-password>
        </div>
        <input *ngIf="field.type !== 'select' && field.type !== 'checkbox' && field.type !== 'password'"
          type="{{ field.type }}" class="form-control" name="{{ field.name }}"
          [placeholder]="getFieldLanguage(field.label)"
          [ngModel]="selectedDmsCredentials ? selectedDmsCredentials[field.name] : field.default" required>
        <input *ngIf="field.type === 'checkbox'" type="checkbox" class="form-control" name="{{field.name}}"
          [placeholder]="getFieldLanguage(field.label)"
          [ngModel]="selectedDmsCredentials ? selectedDmsCredentials[field.name] : (field.default === 'true')">
        <p *ngIf="field.description" class="small">{{getFieldLanguage(field.description)}}</p>


      </div>
      <div style="margin: 10px 0;" *ngIf="selectedDms.module === 'universal'">
        <label>Order Mode</label>
        <select name="orderMode"
          [ngModel]="selectedDmsCredentials ? selectedDmsCredentials['orderMode'] : undefined"
          class="form-control">
          <!-- <option value="undefined" selected>Select Order Mode</option> -->
          <option [ngValue]="undefined">Select Order Mode</option>
          <option value="picturePosition">Picture Position</option>
          <option value="imageType">Image Type</option>
        </select>
      </div>
      <!-- <div class="form-group">
        <label>Username</label>
        <input type="text" #username="ngModel" required ngModel class="form-control" placeholder="Enter Username..."
          [class.is-invalid]="username.invalid && username.touched" name="username">
      </div> -->
      <button *ngIf="!selectedDmsCredentials" [disabled]="isConnecting" class="btn btn-default"
        (click)="connectToDms(connectForm)">Connect</button>
      <button *ngIf="selectedDmsCredentials" class="btn btn-default"
        (click)="editDms(connectForm)">Edit</button>
    </form>
    <a *ngIf="selectedDms.useOauth" class="btn custom-button" [href]="instagramAuthUrl">
      <svg class="instagram-icon mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px"
        height="20px">
        <path
          d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z" />
      </svg> Instagram Connect
    </a>
  </div>
</ng-template>

<!-- Modal Settings -->
<ng-template #dialogSettingsDMS let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>settings.settings</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #dmsSettingsForm="ngForm" novalidate>
      <div class="form-group">
        <label translate>settings.exportLanguage</label>
        <select class="custom-select" name="exportLanguage" [ngModel]="selectedDms.settings?.exportLanguage || null">
          <option [ngValue]="null" disabled>Select Export Language</option>
          <option *ngFor="let lang of allLanguages" [ngValue]="lang.code">
            {{ lang.label }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <p translate>settings.requiredVehicleFields</p>
        <div class="row">
          <div class="col-6" *ngFor="let field of vehicleSpecificationFields">
            <label class="custom-checkbox mt-3">
              <input class="custom-checkbox-input" type="checkbox" [ngModel]="isFieldSelected(field.name)"
                [name]="field.name" (ngModelChange)="onFieldsChange(field.name, $event)">
              <span class="custom-checkbox-text" style="text-transform: none;">{{ field.translations[0].name }}</span>
            </label>
          </div>
        </div>
      </div>
      <button class="btn btn-default" (click)="saveSettings(dmsSettingsForm)">Save</button>
    </form>
  </div>
</ng-template>